module.exports = __webpack_public_path__ + "img/fi-rr-graphic-tablet.cd4422ba.svg";